import React, {useEffect} from "react";
import gsap from 'gsap'

function ButtonContactGroup({props, iconColor,col}) {
  const phoneNumber = "393272441979";
  const message = "Salve, vorrei informazioni sui tuoi servizi";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  useEffect(()=>{
     gsap.fromTo('.buttonContactGroup',
    { opacity: 0, y: 50 },
    { opacity: 1, y: 0, duration: 1, ease: 'power2.out',
      stagger: 0.3,
      scrollTrigger: {
        trigger: '.buttonContactGroup, .myFooter',
        start: 'top 80%',
        toggleActions: 'play none none none'
      }
    }
  );

  }, [])

  return (
    <div className={col}>
      <button className="btn border me-2 rounded-circle buttonContactGroup ">
          <a
            href="https://www.linkedin.com/in/mario-di-stefano-064b791ab/"
            target="_blank"
            rel="noreferrer noopener"
          > <i  className={ iconColor ?`bi bi-linkedin fs-5 text-black ${iconColor}`:"bi bi-linkedin fs-5 text-black"}></i> </a>
      </button>
      <button className="btn border mx-2 rounded-circle buttonContactGroup ">
        <a
          href="https://github.com/mariodistefano"
          target="_blank"
          rel="noreferrer noopener"
        >
          <i className={iconColor ? `bi bi-github fs-5 text-black ${iconColor}`:"bi bi-github fs-5 text-black"}></i> 
        </a>
      </button>
      <button className="btn border mx-2 rounded-circle buttonContactGroup ">
        <a
          href="mailto:mariodistefanoo@live.it?subject=Richiesta di Informazioni&body=Ciao,%0D%0A%0D%0AHo visto il tuo portfolio e vorrei fissare una chiamata con te 😁..."
        >
            <i  className={ iconColor ?`bi bi-envelope fs-5 text-black ${iconColor}` : "bi bi-envelope fs-5 text-black" }></i> 
        </a>
      </button>
      <button className="btn border mx-2 rounded-circle buttonContactGroup "  onClick={() => window.open(whatsappUrl, "_blank")}>
      
            <i  className={ iconColor ?`bi bi-whatsapp fs-5 text-black ${iconColor}` : "bi bi-whatsapp fs-5 text-black" }></i> 
      </button>
      
    </div>
  );
}






export default ButtonContactGroup;
